/**
 * Cookie-based auth helpers for the INSIGHTS dashboard.
 *
 * The Worker mints an HttpOnly cookie at `/v1/insights/manufacturer/auth/verify`
 * (magic-link verification). This module checks for cookie presence — we can't
 * read HttpOnly cookies from JS, so we rely on the server to set a separate
 * non-HttpOnly hint cookie (`insights_session_present=1`) at the same time,
 * which is what we read here. The HttpOnly cookie carries the actual session;
 * the hint cookie is purely for client-side UI gating.
 *
 * Plan refs: INSIGHTS-Final §6.7 (manufacturer auth), §I.6 (magic-link decision).
 */

const HINT_COOKIE = "insights_session_present";

export function hasSessionHint(): boolean {
	if (typeof document === "undefined") return false;
	return document.cookie.split(";").some((c) => c.trim().startsWith(`${HINT_COOKIE}=1`));
}

export function apiBase(): string {
	if (typeof window === "undefined") return "https://staging.api.aivision.space";
	const host = window.location.host;
	if (host.startsWith("staging") || host.startsWith("localhost") || host.startsWith("127.0.0.1")) {
		return "https://staging.api.aivision.space";
	}
	return "https://api.aivision.space";
}
